import Vue from 'vue'

export default Vue.observable({
  unsupported: false,
  minimumVersion: null,
  updateAvailable: false,
})
